var map = {
	"./camera.svg": "./src/assets/img/camera.svg",
	"./demo_site.svg": "./src/assets/img/demo_site.svg",
	"./emoji.svg": "./src/assets/img/emoji.svg",
	"./home_workbench.svg": "./src/assets/img/home_workbench.svg",
	"./icon-CN.svg": "./src/assets/img/icon-CN.svg",
	"./icon-EN.svg": "./src/assets/img/icon-EN.svg",
	"./icon-Exit-fullscreen.svg": "./src/assets/img/icon-Exit-fullscreen.svg",
	"./icon-FAQ.svg": "./src/assets/img/icon-FAQ.svg",
	"./icon-add.svg": "./src/assets/img/icon-add.svg",
	"./icon-authorisation-completed.svg": "./src/assets/img/icon-authorisation-completed.svg",
	"./icon-authorised.svg": "./src/assets/img/icon-authorised.svg",
	"./icon-back.svg": "./src/assets/img/icon-back.svg",
	"./icon-batchdeletion.svg": "./src/assets/img/icon-batchdeletion.svg",
	"./icon-batchsetting.svg": "./src/assets/img/icon-batchsetting.svg",
	"./icon-clientuser.svg": "./src/assets/img/icon-clientuser.svg",
	"./icon-collect.svg": "./src/assets/img/icon-collect.svg",
	"./icon-comment.svg": "./src/assets/img/icon-comment.svg",
	"./icon-communicate.svg": "./src/assets/img/icon-communicate.svg",
	"./icon-completed.svg": "./src/assets/img/icon-completed.svg",
	"./icon-confirmations-type.svg": "./src/assets/img/icon-confirmations-type.svg",
	"./icon-confirmations-type1.svg": "./src/assets/img/icon-confirmations-type1.svg",
	"./icon-contactus.svg": "./src/assets/img/icon-contactus.svg",
	"./icon-download-blue.svg": "./src/assets/img/icon-download-blue.svg",
	"./icon-download-green.svg": "./src/assets/img/icon-download-green.svg",
	"./icon-download.svg": "./src/assets/img/icon-download.svg",
	"./icon-draft.svg": "./src/assets/img/icon-draft.svg",
	"./icon-editor.svg": "./src/assets/img/icon-editor.svg",
	"./icon-elearning.svg": "./src/assets/img/icon-elearning.svg",
	"./icon-entity.svg": "./src/assets/img/icon-entity.svg",
	"./icon-export-blue.svg": "./src/assets/img/icon-export-blue.svg",
	"./icon-export-disabled.svg": "./src/assets/img/icon-export-disabled.svg",
	"./icon-export.svg": "./src/assets/img/icon-export.svg",
	"./icon-fullscreen.svg": "./src/assets/img/icon-fullscreen.svg",
	"./icon-guidance-yellow.svg": "./src/assets/img/icon-guidance-yellow.svg",
	"./icon-guidance.svg": "./src/assets/img/icon-guidance.svg",
	"./icon-historical.svg": "./src/assets/img/icon-historical.svg",
	"./icon-import.svg": "./src/assets/img/icon-import.svg",
	"./icon-in-progress.svg": "./src/assets/img/icon-in-progress.svg",
	"./icon-kcc-portal.svg": "./src/assets/img/icon-kcc-portal.svg",
	"./icon-kpmglogo.svg": "./src/assets/img/icon-kpmglogo.svg",
	"./icon-kpuser.svg": "./src/assets/img/icon-kpuser.svg",
	"./icon-level-01.svg": "./src/assets/img/icon-level-01.svg",
	"./icon-level-02.svg": "./src/assets/img/icon-level-02.svg",
	"./icon-level-03.svg": "./src/assets/img/icon-level-03.svg",
	"./icon-level-04.svg": "./src/assets/img/icon-level-04.svg",
	"./icon-level-05.svg": "./src/assets/img/icon-level-05.svg",
	"./icon-level-06.svg": "./src/assets/img/icon-level-06.svg",
	"./icon-link.svg": "./src/assets/img/icon-link.svg",
	"./icon-long-outstanding.svg": "./src/assets/img/icon-long-outstanding.svg",
	"./icon-long-outstanding1.svg": "./src/assets/img/icon-long-outstanding1.svg",
	"./icon-menu1-2.svg": "./src/assets/img/icon-menu1-2.svg",
	"./icon-menu1-3.svg": "./src/assets/img/icon-menu1-3.svg",
	"./icon-menu1.svg": "./src/assets/img/icon-menu1.svg",
	"./icon-menu2.svg": "./src/assets/img/icon-menu2.svg",
	"./icon-menu3.svg": "./src/assets/img/icon-menu3.svg",
	"./icon-menu4.svg": "./src/assets/img/icon-menu4.svg",
	"./icon-menu5.svg": "./src/assets/img/icon-menu5.svg",
	"./icon-new-left.svg": "./src/assets/img/icon-new-left.svg",
	"./icon-new-zh-left.svg": "./src/assets/img/icon-new-zh-left.svg",
	"./icon-new.svg": "./src/assets/img/icon-new.svg",
	"./icon-news.svg": "./src/assets/img/icon-news.svg",
	"./icon-not-applicable.svg": "./src/assets/img/icon-not-applicable.svg",
	"./icon-not-started.svg": "./src/assets/img/icon-not-started.svg",
	"./icon-notok.svg": "./src/assets/img/icon-notok.svg",
	"./icon-ok.svg": "./src/assets/img/icon-ok.svg",
	"./icon-onboard.svg": "./src/assets/img/icon-onboard.svg",
	"./icon-overview.svg": "./src/assets/img/icon-overview.svg",
	"./icon-overview1.svg": "./src/assets/img/icon-overview1.svg",
	"./icon-pack-down.svg": "./src/assets/img/icon-pack-down.svg",
	"./icon-pack-up.svg": "./src/assets/img/icon-pack-up.svg",
	"./icon-pending-for.svg": "./src/assets/img/icon-pending-for.svg",
	"./icon-pin-fill-hover.svg": "./src/assets/img/icon-pin-fill-hover.svg",
	"./icon-pin-fill.svg": "./src/assets/img/icon-pin-fill.svg",
	"./icon-pin-hover.svg": "./src/assets/img/icon-pin-hover.svg",
	"./icon-pin.svg": "./src/assets/img/icon-pin.svg",
	"./icon-realtime.svg": "./src/assets/img/icon-realtime.svg",
	"./icon-remove.svg": "./src/assets/img/icon-remove.svg",
	"./icon-save.svg": "./src/assets/img/icon-save.svg",
	"./icon-screen.svg": "./src/assets/img/icon-screen.svg",
	"./icon-setting.svg": "./src/assets/img/icon-setting.svg",
	"./icon-setting1.svg": "./src/assets/img/icon-setting1.svg",
	"./icon-setting2.svg": "./src/assets/img/icon-setting2.svg",
	"./icon-setting3.svg": "./src/assets/img/icon-setting3.svg",
	"./icon-statisticaldata.svg": "./src/assets/img/icon-statisticaldata.svg",
	"./icon-table-setting.svg": "./src/assets/img/icon-table-setting.svg",
	"./icon-tips.svg": "./src/assets/img/icon-tips.svg",
	"./icon-total.svg": "./src/assets/img/icon-total.svg",
	"./icon-uncollect.svg": "./src/assets/img/icon-uncollect.svg",
	"./icon-upload-blue.svg": "./src/assets/img/icon-upload-blue.svg",
	"./icon-upload-green.svg": "./src/assets/img/icon-upload-green.svg",
	"./icon-upload.svg": "./src/assets/img/icon-upload.svg",
	"./icon-user.svg": "./src/assets/img/icon-user.svg",
	"./icon-video-fill.svg": "./src/assets/img/icon-video-fill.svg",
	"./icon-video.svg": "./src/assets/img/icon-video.svg",
	"./kpicon-copy.svg": "./src/assets/img/kpicon-copy.svg",
	"./kpicon-eye-disable.svg": "./src/assets/img/kpicon-eye-disable.svg",
	"./kpicon-eye-off.svg": "./src/assets/img/kpicon-eye-off.svg",
	"./kpicon-eye-on-disable.svg": "./src/assets/img/kpicon-eye-on-disable.svg",
	"./kpicon-eye-on.svg": "./src/assets/img/kpicon-eye-on.svg",
	"./kpicon-video.svg": "./src/assets/img/kpicon-video.svg",
	"./normal.svg": "./src/assets/img/normal.svg",
	"./sad.svg": "./src/assets/img/sad.svg",
	"./skull.svg": "./src/assets/img/skull.svg",
	"./sy-btcheck.svg": "./src/assets/img/sy-btcheck.svg",
	"./userlogo.svg": "./src/assets/img/userlogo.svg",
	"./userlogoClient.svg": "./src/assets/img/userlogoClient.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.svg$";